import './styles.scss'

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import ReadMore from 'lib/components/read-more'
import I18n from 'lib/i18n'

import ArrowIcon from '~/scenes/course/show/_assets/arrow-icon.svg'
import { useValues } from 'kea'
import courseLogic from '~/scenes/course/show/logic'

const DEFAULT_OTHER_COURSES_NUMBER = 2

const OtherCourses = ({ courses }) => {
  const { isDesktopWithInBetween } = useValues(courseLogic)
  const [otherCoursesNumberToShow, setOtherCoursesNumberToShow] = useState(DEFAULT_OTHER_COURSES_NUMBER)
  const [isShowMore, setIsShowMore] = useState(false)
  const [isDesktopWithInBetweenBreakpoint, setIsDesktopWithInBetweenBreakpoint] = useState(false)

  useEffect(() => {
    setIsDesktopWithInBetweenBreakpoint(isDesktopWithInBetween)
  }, [isDesktopWithInBetween])

  const handleOnClick = () => {
    setIsShowMore(!isShowMore)

    if (isShowMore) {
      setOtherCoursesNumberToShow(DEFAULT_OTHER_COURSES_NUMBER)
    } else {
      setOtherCoursesNumberToShow(courses.length)
    }
  }

  return (
    <div className={`other-teacher-courses-container${isDesktopWithInBetweenBreakpoint ? ' last' : ''}`}>
      <div className='cards-container'>
        {courses.slice(0, otherCoursesNumberToShow).map(course => (
          <div key={course.id} className='card-container'>
            <div className='card-header'>
              <div className='course-title'>
                <a href={course.url}>{course.title}</a>
              </div>
              <div className='course-price'>
                <div className='price-text-container'>
                  <span>{`${course.price} ${course.currency}`}</span>
                  <span className='per-hour-text'>{` ${I18n.t('courses.show.per_hour_custom')}`}</span>
                </div>
              </div>
            </div>
            <div className='course-content-container'>
              <div className='course-description'>
                <ReadMore text={course.description} numberOfLines={3} external={course.url} />
              </div>
            </div>
          </div>
        ))}
      </div>
      {(otherCoursesNumberToShow < courses.length || isShowMore) && (
        <div className='show-more-section'>
          <div className='show-more-container' onClick={handleOnClick}>
            {isShowMore ? I18n.t('courses.show.show_less') : I18n.t('courses.show.show_more')}
          </div>
          <div className={`arrow-icon-container${isShowMore ? ' more' : ''}`} onClick={handleOnClick}>
            <img className='arrow-icon' alt='arrow icon' src={`${ArrowIcon}`} width={16} height={16} />
          </div>
        </div>
      )}
    </div>
  )
}

OtherCourses.propTypes = {
  courses: PropTypes.array
}

export default OtherCourses
